import { concatClassnames } from "shared/utils/concatClassnames";

interface CardProps {
  children: any;
  className?: string;
  shadow?: boolean;
}
const Card = ({ children, className, shadow = false }: CardProps) => {
  return (
    <div
      className={concatClassnames(
        shadow && "gg-shadow-main",
        "gg-bg-white gg-rounded-sm",
        className
      )}
    >
      {children}
    </div>
  );
};
export default Card;
